import EA from 'helpers/init';

export default EA.Methods.imageLazyLoadAnimation = ($this) => {
    const base = $this;

    const imageEls = $this.querySelectorAll('.carousel-media');

    function handleIntersect(entries, observer) {
        entries.forEach((entry) => {
            if (entry.isIntersecting) {
                imageEls.forEach(img => {
                    img.src = img.dataset.src;
                    img.dataset.src = '';
                });

                setTimeout(() => {
                    $this.classList.add('carousel-start');
                }, 1500);

                observer.disconnect();
            }
            // console.log(entry.isIntersecting);
        });
    }

    function createObserver() {
        const options = {
            root: null,
            rootMargin: '100px',
            threshold: 0,
        };

        const observer = new IntersectionObserver(handleIntersect, options);
        observer.observe(base);
    }
    
    createObserver();
};
